import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { Input } from "@/components/ui/input";

interface SheetPickerProps {
  sheets: string[];
  sheetName: string | null;
  headerRow: number;
  onSheetChange: (sheet: string | null) => void;
  onHeaderRowChange: (row: number) => void;
}

/**
 * Spec 082 — de onde a plataforma lê. A planilha da fábrica tem cinco abas e o cabeçalho na
 * segunda linha, então nenhum dos dois pode ser suposto.
 */
export function SheetPicker({
  sheets,
  sheetName,
  headerRow,
  onSheetChange,
  onHeaderRowChange,
}: SheetPickerProps) {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      <div className="space-y-1.5">
        <Label htmlFor="import-sheet">Aba da planilha</Label>
        <Select
          id="import-sheet"
          value={sheetName ?? ""}
          onChange={(e) => onSheetChange(e.target.value || null)}
          disabled={sheets.length === 0}
        >
          <option value="">
            {sheets.length === 0 ? "Arquivo sem abas (CSV)" : "Escolha a aba"}
          </option>
          {sheets.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </Select>
      </div>
      <div className="space-y-1.5">
        <Label htmlFor="import-header-row">Linha do cabeçalho</Label>
        <Input
          id="import-header-row"
          type="number"
          min={1}
          placeholder="1"
          value={headerRow}
          onChange={(e) => onHeaderRowChange(Number(e.target.value) || 1)}
        />
        <p className="text-[12px] text-text-secondary">
          Em que linha do arquivo estão os nomes das colunas.
        </p>
      </div>
    </div>
  );
}
